import { PolylineSymbol as sPolylineSymbol } from "@evergis/sgis/es/symbols/PolylineSymbol";
import { Crs } from "@evergis/sgis/es/Crs";
import { Polyline } from "@evergis/sgis/es/features/Polyline";
import { Render } from "@evergis/sgis/es/renders/Render";
import { PolylineSymbols, isSimplePolylineSymbol, isDashedBrush } from "../../interfaces/style";
import { getParameterValue } from "../../evergis/core/classification/getFromClassified";
import { getLineDash } from "./SymbolRenderer/strokeStyle";
import { getHexColor } from "../../utils/color";
import { clamp } from "../../utils/math";
import { PREVIEW_LIMITS } from "./SymbolRenderer/previewLimits";
import { SGisMiterSymbol } from "./SGisMiterSymbol";

export class SGisPolylineSymbol extends sPolylineSymbol {
  private miterSymbol: SGisMiterSymbol;

  constructor(public originalSymbol: PolylineSymbols) {
    super({
      strokeColor: getHexColor(getParameterValue(originalSymbol.stroke?.color)),
      strokeWidth: clamp(
        getParameterValue(originalSymbol.stroke?.width),
        PREVIEW_LIMITS.STROKE_WIDTH_MIN,
        PREVIEW_LIMITS.STROKE_WIDTH_MAX,
      ),
      lineDash: getLineDash(originalSymbol.stroke),
      lineCap: isDashedBrush(originalSymbol.stroke) ? "square" : "round",
    });

    this.miterSymbol = new SGisMiterSymbol({
      ...originalSymbol,
      type: "polylineMiterSymbol",
    });
  }

  renderFunction(feature: Polyline, resolution: number, crs: Crs): Render[] {
    if (!isSimplePolylineSymbol(this.originalSymbol)) return super.renderFunction(feature, resolution, crs);

    const featureCopy = feature.clone();

    const miterSymbolRenders = this.miterSymbol.getRenders(featureCopy, resolution, crs, false);

    return [...super.renderFunction(featureCopy, resolution, crs), ...miterSymbolRenders];
  }

  clone() {
    return new SGisPolylineSymbol(this.originalSymbol);
  }
}
